import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const GET_SERVICE_ID_LOADING = 'GET_SERVICE_ID_LOADING';
export const GET_SERVICE_ID_SUCCESS = 'GET_SERVICE_ID_SUCCESS';
export const GET_SERVICE_ID_REJECT = 'GET_SERVICE_ID_REJECT';

//* ACTIONS ------------------------------------------------
export const getServiceIdLoading = () => ({ type: GET_SERVICE_ID_LOADING });
export const getServiceIdSuccess = (payload) => ({ type: GET_SERVICE_ID_SUCCESS, payload });
export const getServiceIdReject = (payload) => ({ type: GET_SERVICE_ID_REJECT, payload });

//* REQUEST SERVICE ---------------------------------------
export const getServiceIdRequest = async ({ params = {}, id }, getState) => {
    const options = await withToken({
        method: Methods.GET,
        params,
    }, getState);
    return request(`/api/Clients/Services/${id}/edit`, options);
};